var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import classnames from 'classnames';
import OutlinedSearch from 'acud-icon/lib/icons/OutlinedSearch';
import OutlinedLoading from 'acud-icon/lib/icons/OutlinedLoading';
import useMergedState from 'rc-util/lib/hooks/useMergedState';
import { ConfigContext } from '../config-provider';
import Select from '../select';
import useCombinedRefs from '../_util/hooks/useCombinedRefs';
import Input from '../input';
import Button from '../button';
const { Option } = Select;
const Search = React.forwardRef((props, ref) => {
    // props
    const { loading, className, multipleOption = [], multipleValue, multipleDefaultValue, enterButton = false, // 如果是boolean,表示加强，如果是字符串表示文字按钮
    size, // 主要是input大小改变，按钮的大小也需要改变
    disabled, // 主要是input 编辑状态改变，按钮的点击状态也需要改变
    onCompositionStart, onCompositionEnd, onChange: customChange, // 主要是改写onChange
    onSearch: customSearch, // 绑定search函数
    onChangeMultiple: customChangeMultiple, addonSelectStyle } = props, otherProps = __rest(props, ["loading", "className", "multipleOption", "multipleValue", "multipleDefaultValue", "enterButton", "size", "disabled", "onCompositionStart", "onCompositionEnd", "onChange", "onSearch", "onChangeMultiple", "addonSelectStyle"]);
    const [multipleMergeValue, setMultipleMergeValue] = useMergedState(multipleDefaultValue, {
        value: multipleValue,
    });
    const composedRef = React.useRef(false);
    // 变量
    // search里面主要是对enterButton做处理
    let button;
    let addonBefore;
    const ifMultiple = !!multipleOption.length;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const { prefixCls: customizePrefixCls } = props;
    const prefixCls = getPrefixCls('input-search', customizePrefixCls);
    const ifControlMutipleValue = 'multipleValue' in props;
    // 样式
    const classes = classnames(className, prefixCls, {
        [`${prefixCls}-multiple`]: ifMultiple,
        [`${prefixCls}-enter-button`]: enterButton,
        [`${prefixCls}-enter-button-disabled`]: disabled,
    });
    // 点击搜索按钮样式
    const searchIconClass = `${prefixCls}-icon`;
    const searchLoadingIconClass = `${prefixCls}-loading-icon`;
    // ref
    const inputRef = React.useRef(null);
    const combinedRef = useCombinedRefs(ref, inputRef);
    // 函数
    const onChange = useCallback((e) => {
        if (e && e.target && e.type === 'click' && customSearch) {
            customSearch(e.target.value, e);
        }
        customChange && customChange(e);
    }, [customChange, customSearch]);
    const onSearch = useCallback((e) => {
        var _a;
        const value = (_a = combinedRef.current) === null || _a === void 0 ? void 0 : _a.value;
        const realValue = ifMultiple
            ? { type: multipleMergeValue, value }
            : value;
        if (composedRef.current) {
            return;
        }
        customSearch && customSearch(realValue, e);
    }, [combinedRef, ifMultiple, multipleMergeValue, customSearch]);
    const onChangeMultiple = useCallback((value) => {
        // 如果是不受控，就自己调用set
        if (!ifControlMutipleValue) {
            setMultipleMergeValue(value);
        }
        customChangeMultiple === null || customChangeMultiple === void 0 ? void 0 : customChangeMultiple(value);
    }, [customChangeMultiple, ifControlMutipleValue, setMultipleMergeValue]);
    // 主要逻辑
    // 如果是enterButton对象，就表示ReactElement
    const buttonContent = enterButton === true ? <OutlinedSearch /> : enterButton;
    // icon还是交给button处理吧
    button = (<Button key="enterButton" type={enterButton ? 'primary' : undefined} size={size} loading={loading} disabled={disabled} onClick={onSearch} onMouseDown={(e) => {
            e.preventDefault();
        }} icon={buttonContent}></Button>);
    // 多条件搜索
    if (multipleOption.length) {
        addonBefore = (<Select value={multipleMergeValue} onChange={(value) => onChangeMultiple(value)} disabled={disabled} style={addonSelectStyle}>
                {multipleOption.map((item) => {
                const { value, label } = item || {};
                return (<Option value={value} key={value}>
                            {label}
                        </Option>);
            })}
            </Select>);
    }
    const handleOnCompositionStart = (e) => {
        composedRef.current = true;
        onCompositionStart === null || onCompositionStart === void 0 ? void 0 : onCompositionStart(e);
    };
    const handleOnCompositionEnd = (e) => {
        composedRef.current = false;
        onCompositionEnd === null || onCompositionEnd === void 0 ? void 0 : onCompositionEnd(e);
    };
    const baseProps = Object.assign(Object.assign({}, otherProps), { size, ref: combinedRef, onChange,
        disabled, onPressEnter: onSearch, onCompositionStart: handleOnCompositionStart, onCompositionEnd: handleOnCompositionEnd, addonBefore: ifMultiple && addonBefore });
    let suffix = loading ? (<OutlinedLoading className={searchLoadingIconClass} animation="spin"/>) : (<OutlinedSearch onClick={onSearch} onMouseDown={(e) => {
            e.preventDefault();
        }} className={searchIconClass} disabled={disabled}/>);
    const realProps = enterButton === false || typeof enterButton === undefined
        ? Object.assign(Object.assign({}, baseProps), { suffix }) : baseProps;
    return (<span className={classes}>
            <Input {...realProps} ref={combinedRef}/>
            {enterButton && button}
        </span>);
});
export default Search;
